import { Const } from '../lib/const.cls'

export const mutations = {
  // state mutation
  [Const.SET_TRADER_BASIC_INFO]: (state, data) => {
  	state.TRADERBASICINFO = data
  },

  [Const.SET_TRADERING_INFORMATION]: (state, data) => {
  	state.TRADERINGINFO = data
  },

  [Const.SET_QR_CODE]: (state, data) => {
  	state.QRCODE = data
  },
  [Const.SET_INERTVAL]: (state, data) => {
    state.intervalid = data
  },
  [Const.SET_HISTORY]: (state, data) => {
    state.TRADERINGHISTORY = data
  },
  [Const.SET_TRADING_ACCOUNT]: (state, data) => {
    state.TRADERINGACCOUNTS = data
  },
  [Const.SET_OPEN_POSITION]: (state, data) => {
    state.OPEN_POSITION = data
  },
  [Const.SET_MARKET_DEPTH]: (state, data) =>{
    state.MARKET_DEPTH = data
  },
  [Const.SET_OPEN_HOLDINGS]: (state, data) =>{
    state.OPEN_HOLDINGS = data
  },

  [Const.SET_CLOSED_ORDER]: (state, data) => {
    state.CLOSED_ORDER = data
  },
  [Const.SET_CLOSED_ORDER]: (state, data) => {
    state.CLOSED_ORDER = data
  },
  [Const.SET_MARGIN_INFO]: (state, data) => {
    state.MARGIN_INFO = data
  },
  [Const.SET_DEPOSIT_HISTORY]: (state, data) => {
    state.DEPOSIT_HISTORY = data
  },
  [Const.SET_WITHDRAWAL_HISTORY]: (state, data) => {
    state.WITHDRAWAL_HISTORY = data
  },
  [Const.SET_BONUS_HISTORY]: (state, data) => {
    state.BONUS_HISTORY = data
  }, 
  [Const.SET_BANKS_DETAIL]: (state, data) => {
    state.BANKS_DETAIL = data
  },
  [Const.SET_CARDS_LIST]: (state, data) => {
    state.CARD_LIST = data
  },
  [Const.SET_TICKET_LIST]: (state, data) => {
    state.TICKET_LIST = data
  },
  [Const.SET_DOCUMENT_LIST]: (state, data) => {
    state.DOCUMENT_LIST = data
  },
  [Const.SET_TICKET_VIEW_LIST]: (state, data) => {
    state.TICKET_VIEW = data
  },
  [Const.SET_LOADER_STATUS]: (state, data) => {
    state.LOADER_STATUS = data
  },

  [Const.SET_DEPOSIT_ADDRESS]: (state, data) => {
    state.DEPOSIT_ADDRESS = data
  },
  [Const.SET_GRAPH_DATA]: (state, data) => {
    state.GRAPH_DATA = data
  },
  [Const.SET_CURRENT_TRADING_ACCOUNT]: (state, data) => {
    state.CURRENT_TRADING_ACCOUNT = data
  },
  [Const.SET_OPEN_ORDER]: (state, data) => {
    state.OPEN_ORDERS = data
  },
  [Const.SET_ORDER_HISTORY]: (state, data) => {
    state.ORDER_HISTORY = data
  },
  [Const.SET_USER_LOGS]: (state, data) =>{
    state.USER_LOGS = data
  },
  [Const.SET_EXCHANGE_MSG]: (state, data) =>{
    state.EXCHANGE_MSG = data
  },
  [Const.SET_USER_EXTRA_INFO]: (state, data) =>{
    state.USER_EXTRA_INFO = data
  },
  [Const.SET_SOCKET_INDICATOR]: (state, data) =>{
    state.SOCKET_INDICATOR = data
  },
  [Const.SET_ALL_ISINS]: (state, data) =>{
    state.ALL_ISINS = data
  },  
  [Const.SET_SCRIP_INFO]: (state, data) =>{
    state.SCRIP_INFO = data
  },
  [Const.SET_MARKET_STATUS]: (state, data) =>{
    state.MARKET_STATUS = data
  },

  [Const.SET_WATCH_LIST]: (state, data) =>{
    state.WATCH_LIST = data
  },
  
  
  
}



// WEBPACK FOOTER //
// ./src/plugins/scalpert/provider/candle-history/store-addons/mutations.js